import { FilterGroup } from 'types';
import { IGetFilterGroupsProps } from '../types';
import { getFundsMaturityFilter } from './fundsMaturity';

export const getFinanceGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'FINANCE',
    filters: [getFundsMaturityFilter(props)],
  };
};
